/**
 * Embedding-model identity for camera part identification.
 *
 * Kept in its own DOM-free module so both the main-thread engine
 * (`identifyEngine.ts`) and the inference Web Worker (`identifyWorker.ts`) can
 * import it without pulling in each other (the worker must NOT import the engine,
 * which would recursively spawn another worker).
 *
 * The query and the index MUST be embedded with the same model, so this is the
 * single source of truth and is sent to the backend as `model_id`; vectors with
 * a different `model_id` are ignored, so changing either value invalidates the
 * existing index.
 *
 * DINOv2 is a pure vision model purpose-built for image feature extraction
 * (unlike CLIP, which needs text input and isn't handled by the
 * `image-feature-extraction` pipeline).
 */

export const IDENTIFY_MODEL_NAME = 'Xenova/dinov2-small';

// q8 (int8-quantised) weights — ~22 MB download, and crucially a much smaller
// WASM heap footprint than fp32 (~88 MB). iPad Safari aborts fp32 with
// `RangeError: Out of memory` → ORT then reports "no available backend found".
// Accuracy loss is negligible for cosine ranking. The dtype is part of the
// embedding-space identity, so it's baked into the model_id below.
export const IDENTIFY_DTYPE = 'q8';

export const IDENTIFY_MODEL_ID = `${IDENTIFY_MODEL_NAME}@${IDENTIFY_DTYPE}`;
